
export default class CacheManager {
    constructor() {
    }
    setCache(key, value, isBin=false) {
        let strValue = value;
        if(isBin) {
            const binData = new Uint8Array(value);
            strValue = binData.reduce((str, byte) => str + String.fromCharCode(byte), '');
        }
        else strValue = JSON.stringify(value);
        localStorage.setItem(key, strValue);
    }
    getCache(key, isBin=false) {
        const cache = localStorage.getItem(key);
        if(!cache) return;
        if(isBin) {
            const bin = localStorage.getItem('model');
            const binaryData = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
                binaryData[i] = bin.charCodeAt(i);
            }
            return new Blob([binaryData], { type: 'application/octet-stream' });
        }
        return JSON.parse(cache);
    }
    cacheProduct(newIndex = undefined) {
        let index = isNaN(newIndex) ? this.getCache("product") : newIndex;
        if(isNaN(index)) index = 0;
        this.setCache("product", index);
        return index;
    }
    remove(key) {
        localStorage.removeItem(key);
    }
    size() {
        let totalSize = 0;
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            const value = localStorage.getItem(key);
            totalSize += key.length + value.length * 2; // Estimate size in bytes
        }
        const sizeInMB = totalSize / (1024 * 1024); // Convert bytes to megabytes
        return sizeInMB.toFixed(2);
    }
    clear(key) {
        const delIds = [];
        for (let i = 0; i < localStorage.length; i++) {
            const curKey = localStorage.key(i);
            if(curKey === key) delIds.push(key);
        }
        delIds.forEach(key => localStorage.removeItem(key));
    }
    clearAll() {
        localStorage.clear();
    }
}


